<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtext: {
      type: String,
      default: ''
    },
  }
}
</script>

<template>
  <div class="hs-section-1">
    <slot name="title">
      <div v-if="title" class="header">
        <div class="title">{{title}}</div>
        <div class="subtext">{{subtext}}</div>
      </div>
    </slot>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-section-1{
  width: 100%;
  border-radius: 8px;
  background-color: $color_black_0;
  margin-bottom: 8px;
  overflow: hidden;
  >.header{
    @extend .flex-start;
    @extend .hs-font-subtitle-big;
    align-items: baseline;
    flex-wrap: wrap;
    padding: 16px 16px 8px 16px;
    >.title{
      font-weight: 500;
      margin-right: 4px;
    }
    >.subtext{
      @extend .hs-font-caption-1;
      color: $color_black_80;
    }
  }
}
</style>
